import { useEffect, type FC } from 'react';
import { StyleSheet, type DimensionValue, type StyleProp, type ViewStyle } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	height: number;
	width?: DimensionValue;
	round?: boolean;
	style?: StyleProp<ViewStyle>;
}

const REPEAT_FOREVER = -1;

const SkeletonBlock: FC<Props> = ({ height, width, round = false, style }) => {
	const opacity = useSharedValue(Dimens.opacity100);

	useEffect(() => {
		opacity.value = withRepeat(
			withTiming(Dimens.opacity50, { duration: Dimens.animationDuration800 }),
			REPEAT_FOREVER,
			true,
		);
	}, [opacity]);

	const pulseStyle = useAnimatedStyle(() => ({ opacity: opacity.value }));

	return (
		<Animated.View
			style={[
				styles.block,
				{ height, width, borderRadius: round ? Dimens.borderRadius99 : Dimens.borderRadius4 },
				pulseStyle,
				style,
			]}
		/>
	);
};

const styles = StyleSheet.create({
	block: {
		backgroundColor: Colors.gray200,
	},
});

export default SkeletonBlock;
